import React from 'react'
import { P } from '@farewill/ui'
import { GTR } from '@farewill/ui/tokens'
import { PRODUCTS } from 'lib/products/constants'
import { RoleSection, RoleTemplate, RoleTitle, RoleUl } from '../RoleTemplate'

const WillsProbateTalentBank = (): React.JSX.Element => (
  <RoleTemplate
    roleName="Wills & Probate (Talent Bank)"
    roleDescriptor="probate specialists"
    roleUrl="https://dignity.kallidusrecruit.com/vacancyinformation.aspx?vguid=e73065d3-86e6-4538-83ec-588deeba29a5"
    location="Maidenhead (Hybrid – 3 days on-site)"
    salary="Competitive (depending on experience)"
    contractType="Full-time, Permanent"
    closingDate="28th August 2025"
    product={PRODUCTS.PROBATE}
    content={
      <>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>Register Your Interest</RoleTitle>
          <P>
            We&apos;re growing fast and whether you&apos;re early in your career
            or a seasoned probate specialist, we&apos;d love for you to be part
            of our next chapter.
          </P>
          <P>
            We&apos;re building our Wills & Probate team in Maidenhead and this
            is your opportunity to register your interest and be first in line
            for future roles.
          </P>
        </RoleSection>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>The Role</RoleTitle>
          <P>
            We help families navigate some of the most difficult times in their
            lives. Whether you&apos;re legally qualified or come from a strong
            background in wills, tax, trusts, or private client services,
            you&apos;ll play a key role in guiding estates through the probate
            process with care, clarity, and professionalism.
          </P>
          <P>
            As part of a brand new and fast-growing probate team, you&apos;ll be
            supporting estates large and small, from initial client contact to
            final distribution.
          </P>
          <P>
            We welcome applications at all levels. If you bring some of the
            following, we&apos;d love to hear from you:
          </P>
          <RoleUl>
            <li>
              Experience in probate, estate administration, wills, trusts, or
              tax
            </li>
            <li>
              A background in a law firm, legal services provider, or similar
              environment
            </li>
            <li>
              Empathy, professionalism, and confidence when supporting clients
            </li>
            <li>
              Strong attention to detail and the ability to manage competing
              priorities
            </li>
            <li>
              A legal qualification (Solicitor, CILEX, etc.) or STEP/SFE
              accreditation is great but not essential
            </li>
          </RoleUl>
        </RoleSection>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>Key Responsibilities</RoleTitle>
          <P>As part of our expanding team, you could be:</P>
          <RoleUl>
            <li>
              Supporting families through probate with clarity and compassion
            </li>
            <li>
              Preparing key documents and guiding estates through to
              distribution
            </li>
            <li>Advising on wills, intestacy, inheritance tax, and trusts</li>
            <li>
              Contributing to a better, faster, and more human probate
              experience
            </li>
            <li>
              Helping us grow – whether by mentoring others, improving how we
              work, or sharing your legal knowledge
            </li>
          </RoleUl>
        </RoleSection>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>About You</RoleTitle>
          <P>
            We&apos;re open to applicants at all levels of experience — whether
            you&apos;re early in your career or have been in private client
            practice for years, we want to hear from you if you have:
          </P>
          <RoleUl>
            <li>
              A background in probate, estate administration, wills, tax, or
              trusts
            </li>
            <li>
              Experience in a law firm, legal services provider, or related
              setting
            </li>
            <li>
              A legal qualification (Solicitor, CILEX, or equivalent) —
              desirable but not essential
            </li>
            <li>
              A confident, professional communication style with empathy for
              clients
            </li>
            <li>High attention to detail and strong organisational skills</li>
            <li>
              The ability to work independently and as part of a collaborative
              team
            </li>
            <li>A desire to grow in a fast-moving, purpose-led organisation</li>
            <li>STEP or SFE accreditation is a bonus but not required</li>
          </RoleUl>
        </RoleSection>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>What We Offer</RoleTitle>
          <RoleUl>
            <li>Competitive salary depending on experience</li>
            <li>25 days holiday + bank holidays</li>
            <li>x2 Life Assurance</li>
            <li>Pension scheme</li>
            <li>Hybrid working (3 days in our Maidenhead office)</li>
            <li>Clear development and progression paths</li>
            <li>
              The opportunity to help shape a new team and make a real
              difference to people at a vulnerable time
            </li>
          </RoleUl>
        </RoleSection>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>Why Join the Talent Bank?</RoleTitle>
          <P>
            By registering your interest, you&apos;ll be the first to hear about
            upcoming roles in our dynamic, purpose-driven team. Whether
            you&apos;re actively looking or just exploring future opportunities,
            we&apos;d love to stay in touch.
          </P>
          <P>
            Together, we&apos;re rethinking how people experience loss — and
            building something meaningful, with people at its heart.
          </P>
        </RoleSection>
      </>
    }
  />
)

export default WillsProbateTalentBank
